import { useState, useEffect, useContext } from 'react'
import { useTranslation } from "react-i18next";
import {  Link, useLocation } from "react-router-dom";

import { Img } from "../../../components/Elements";
import { AppContext } from "../../../Context";

import { MdQuestionAnswer, MdEdit, MdOutlineMoreVert, MdOutlineDeleteOutline, MdOutlineContentCopy } from "react-icons/md";
import { Config } from '../../../inc/Config';

export default function BooksList({ v, locked }) {

    

    const { t } = useTranslation();
    const location = useLocation();

    // const regex = /(<([^>]+)>)/gi;
    const { successData, userData } = useContext(AppContext);
    const [open, setopen] = successData;
    const [userinfo, setuserinfo] = userData;

    
    return (
        <Link target={userinfo?._id ? '_blank' : false} to={userinfo?._id ? `${Config?.imgUrl}${v?.book}/index.html` : '/login'} state={!userinfo?._id ? { previousLocation: location } : false} className='audioList bookList'>
            <Img src={`img/230x230/${v?.cover[0]}`} />
            <h5>{v?.name?.name} <b>({v?.part?.name})</b></h5>

            <ul>
                <li className='tag orange'>{t("class")} {global?.Classes[v?.classes[0]]}</li>
                <li className='tag'>{v?.cat?.name}</li>
            </ul>
        </Link>
    )
}
